export default {
    userTypes: {
        'client': 'Client',
        'none': "Aucun",
    },
}
